// @flow
import ContactWrapper from 'components/contact/ContactWrapper';
import { connect } from 'react-redux';
import { fetchThemes, fetchQuestions } from 'actions/faqActions';

import type { DispatchProps, StateProps } from 'components/contact/ContactWrapper';
import type { DispatchType, StateType } from 'types/Actions';

import { withRouter } from 'react-router-dom';

export default withRouter(
  connect(
    (state: StateType): StateProps => ({
      themes: state.faqState.themes,
      blocs_faq: state.settingsState.blocs_faq,
    }),
    (dispatch: DispatchType): DispatchProps => ({
      fetchThemes: () => dispatch(fetchThemes()),
      fetchQuestions: () => dispatch(fetchQuestions())
    })
  )(ContactWrapper)
);
